import { z } from "zod";

/**
 * Search autocomplete suggestions — taxonomy terms (brand / theme / tcg /
 * tcg_set / product_type) matching a partial query. Served by
 * `GET /api/search/suggest?q=` (ILIKE on the trgm-indexed `taxonomy_items.name`).
 * Selecting a suggestion runs a normal search for its label.
 *
 * Schema-first: types derived via `z.infer` — see pin.ts header on why
 * bidirectional `pinned()` does not apply.
 */
// eslint-disable-next-line no-restricted-syntax -- schema-first declaration: SearchSuggestion is z.infer<typeof SearchSuggestionSchema>.
export const SearchSuggestionSchema = z.object({
  label: z.string(),
  type: z.string(),
  slug: z.string().nullable(),
});
export type SearchSuggestion = z.infer<typeof SearchSuggestionSchema>;

// eslint-disable-next-line no-restricted-syntax -- schema-first declaration: SearchSuggestResponse is z.infer<typeof SearchSuggestResponseSchema>.
export const SearchSuggestResponseSchema = z.object({
  suggestions: z.array(SearchSuggestionSchema),
});
export type SearchSuggestResponse = z.infer<typeof SearchSuggestResponseSchema>;
